import folderForestStore from '../store/store';
export default function getSelectedNode() {
    return folderForestStore.selectedNode;
}
//# sourceMappingURL=getSelectedNode.js.map